import { DISTRIBUTORS_LIST_PATH, DISTRIBUTOR_CREATE_PATH } from 'shared/constants/routes';
import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
var DistributorsList = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/DistributorsList');
});
var DistributorCreate = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/DistributorCreate');
});
export var Routing = function Routing() {
    return RouteGenerator({
        list: {
            path: DISTRIBUTORS_LIST_PATH,
            component: DistributorsList,
            exact: true
        },
        create: {
            path: DISTRIBUTOR_CREATE_PATH,
            component: DistributorCreate,
            exact: true
        }
    });
};
